import type {
    MediaItem,
} from "@mrflark/spl_service_model";
import {
    Sparkles,
} from "lucide-preact";
import {
    type ReactElement,
    useEffect,
    useState,
} from "preact/compat";
import {
    splClient,
} from "../../api/client.ts";
import {
    useAuthStore,
} from "../../stores/authStore.ts";

type RecommendationsSidebarProps = {
    refreshKey: number;
    onNavigateToItem: (item: MediaItem) => void;
};

export const RecommendationsSidebar = ({
    refreshKey,
    onNavigateToItem,
}: RecommendationsSidebarProps): ReactElement | null => {
    const {
        userId,
    } = useAuthStore();
    const [items, setItems] = useState<MediaItem[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!userId) return;
        setLoading(true);
        splClient.getProfileRecommendations(String(userId), 5)
            .then((result) => setItems(result.items))
            .catch(() => {/* ignore */})
            .finally(() => setLoading(false));
    }, [userId, refreshKey]);

    if (!userId || (items.length === 0 && !loading)) return null;

    return (
        <div className="mt-4 pt-4 border-t border-border">
            <h3 className="text-xs font-medium text-text-secondary uppercase tracking-wider mb-3 flex items-center gap-1.5">
                <Sparkles size={14} />
                Suggested for you
            </h3>
            {loading
                ? <div className="text-xs text-text-muted">Loading...</div>
                : (
                    <div className="space-y-2">
                        {items.map((item) => (
                            <button
                                type="button"
                                key={item.id}
                                onClick={() => onNavigateToItem(item)}
                                className="w-full flex items-center gap-2 p-1.5 rounded-lg hover:bg-bg-tertiary transition-colors text-left"
                            >
                                <img
                                    src={item.thumbnail_url || item.media_url}
                                    alt=""
                                    className="w-10 h-10 rounded object-cover flex-shrink-0"
                                    loading="lazy"
                                />
                                <span className="text-xs text-text-secondary truncate">
                                    {item.tags?.slice(0, 3).join(", ") ||
                                        "Untitled"}
                                </span>
                            </button>
                        ))}
                    </div>
                )}
        </div>
    );
};
